"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4678],{

/***/ 34678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26628);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44012);




var InStockProducts = function(param) {
    var children = param.children, qty = param.qty, stockID = param.stockID, stockValue = param.stockValue;
    var outOfStock = Boolean(+(0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        var ref;
        return (ref = state.general.coreConfigs.catalog_products_homepage_out_of_stock_items) === null || ref === void 0 ? void 0 : ref.value;
    }));
    var value = stockID && stockValue ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "search__fm_dr_Message",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            id: stockID,
            defaultMessage: stockValue
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: !outOfStock && qty === 0 ? value : children
    });
};
/* harmony default export */ __webpack_exports__["default"] = (InStockProducts);


/***/ })

}]);